{
  "new-team": "New Team",
  "add-teams": "Add Teams",
  "create-team-header": "Create New Team",
  "add-team-header": "Add New Team",
  "update-team-header": "Edit Team",
  "move-team-header": "Move Team",
  "add-members-header": "Add members",
  "move-team-disclaimer": "Please select where you would like to move this team. Please note that any sub teams will be moved with its parent.",
  "delete-team-header": "Delete Team",
  "delete-team-disclaimer": "Once deleted, this team will be permanently deleted. Are you sure you want to do this?",
  "remove-member-header": "Remove member",
  "remove-team-user-disclaimer": "Once removed, this member will no longer be part of this team.",
  "teams-name-label": "Please enter a new team name:",
  "teams-name-placeholder": "Team's name",
  "teams-parent-placeholder": "Select parent team",
  "no-parent": "No Parent Team",
  "parent": "Parent Team: {{name}}",
  "sub-team-context": "Manage Team A team sub teams. Add, move, or rearrange teams.",
  "team-user-context": "Manage {{name}} members. Set roles, add and remove members.",
  "save": "Spara",
  "add": "Add",
  "add-members": "Add members",
  "create": "Skapa",
  "move": "Flytta",
  "delete": "Ta bort",
  "cancel": "Avbryt",
  "users": "Användare",
  "members": "Members",
  "sub-teams": "Sub Team",
  "sub-teams_plural": "Sub Teams",
  "associated-teams": "Associated Teams",
  "team-not-found": "Team not found",
  "team-user-not-found": "Member not found",
  "name": "Namn",
  "email": "E-post",
  "role": "Roll",
  "status": "Status",
  "managers": "Managers",
  "find-teams": "Find teams",
  "find-member": "Find a member",
  "banner-title": "Setup your organization with teams",
  "banner-subtitle": "Collegial platform Teams is where set up your working teams with their rights. Here’s what you can do.",
  "banner-list-teams": "List Teams",
  "banner-list-teams-subtitle": "Lorem ipsum dolor amet mustache knausgaard",
  "banner-create-new-teams": "Create New Teams",
  "banner-create-new-teams-subtitle": "Lorem ipsum dolor amet mustache knausgaard",
  "banner-manage-teams": "Manage Teams",
  "banner-manage-teams-subtitle": "Lorem ipsum dolor amet mustache knausgaard",
  "role-member": "Chef",
  "role-member-description": "Members are Collegial users who are part of a team.",
  "role-manager": "User",
  "role-manager-description": "Team managers can view their assigned members and their analytics.",
  "change-role-header": "Ändra roll",
  "select-user-role": "{{user}} roll",
  "tooltip-information-label" : "INFORMATION",
  "tooltip-parent-team-description": "A parent team is a team that has other teams underneath it. The teams under the parent team are called associated teams."
}
